/*
 * Text input — replaces Bootstrap's `.form-control`, replicated 1:1 from the theme
 * via the token bridge (no hardcoded hex/px). Values lifted from the compiled
 * `.form-control` rule (`bootstrap-limitless/forms.less`): 1px #aaa border, 5px
 * radius, 36px height, 7/12 padding, 13/20 type, #fff bg, #999 placeholder.
 */
.root {
	display: block;
	width: 100%;
	height: var(--input-height);
	padding: var(--padding-base-y) var(--padding-base-x);
	font-size: var(--font-size-base);
	line-height: var(--line-height-base);
	color: var(--input-color);
	background-color: var(--input-bg);
	border: 1px solid var(--input-border);
	border-radius: var(--input-border-radius);
	box-sizing: border-box;
	/* No transition: this theme changes neither border nor shadow on focus, so
	   Bootstrap's `border-color`/`box-shadow` transition was a no-op — and keeping it
	   left the invalid border stuck mid-transition under React re-renders. Drop it so
	   the valid↔invalid border switch is instant (like the label's red). */
}

.root::placeholder {
	color: var(--input-color-placeholder);
}

/* Invalid: red border (theme's `.has-error .form-control` used @state-danger-text).
   Base UI sets data-invalid on the control itself, so this is self-contained. */
.root[data-invalid] {
	border-color: var(--state-danger-text);
}

/* Multi-line variant (Textarea): drop the fixed control height. */
.textarea {
	height: auto;
}

.root:focus {
	outline: 0;
	box-shadow: 0 0 0 3px var(--color-primary-focus-ring);
}

/* Disabled + readonly share the muted background; only disabled blocks the cursor. */
.root:disabled,
.root[readonly] {
	background-color: var(--input-bg-disabled);
}

.root:disabled {
	cursor: var(--cursor-disabled);
}
